<script>

</script>

<style>

.bebas-bold {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
}

.hero img {
	width: 100%;
}

.intro-container {
	padding: 5rem 0rem;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	border-bottom: 0.2rem solid rgba(0,175,170,1);
	justify-content: center;
	align-content: center;
}

.intro-child {
	text-align: center;
	margin: 5px;
	padding: 10px;
}

.intro-child img {
	padding: 10px;
	height: 80px;
	width: 80px;
	opacity: 0.5;
}
.intro-child a {
	font-size: 1.5rem;
	display: block;
	color: black; 
}


</style>

<div class="hero">
	<img src="/pictures/Vitals_hero-02d.png">
</div>

<div class="intro-container bebas-bold">
	<div class="intro-child">
		<img src="pictures/heartbeat.svg" height="80px" width="80px" alt="heartbeat_icon">
		<a href="#score">SCORE</a>
	</div>
	<div class="intro-child">
		<img src="pictures/medicine.svg" height="80px" width="80px" alt="Triage_icon">
		<a href="#triage">Triage</a>	
	</div>
	<div class="intro-child">
		<img src="pictures/medical-book.svg" height="80px" width="80px" alt="Medical_book">
		<a href="#training">Training</a>
    </div>
</div>